import styled from 'styled-components';

export const TemplatePrintDefaultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DescriptionText = styled.p`
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.5;
`;

export const FieldBlock = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 12px 0;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const SettingRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const FieldLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
`;

export const ToggleLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.75);
`;

export const InheritedText = styled.div`
  margin-top: 8px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
  font-style: italic;
`;

export const OverrideControlWrapper = styled.div`
  margin-top: 8px;
  width: 100%;

  .ant-select,
  .ant-input-number,
  .ant-input {
    width: 100%;
  }
`;

export const FooterRow = styled.div`
  margin-top: 8px;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
`;
